'use strict';

function LoanApplicationTray() {
  var _this3 = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();
    this.path = window.location.pathname;
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this.trayItems = [{
      title: 'Get started',
      url: this.paths.loans.application_flow_start,
      editable: false,
      completed: this.hasLoanApplication()
    }, {
      title: 'Phone verification',
      url: this.paths.loans.application_flow_phone_verification,
      editable: false,
      completed: this.hasPhoneVerification()
    }, {
      title: 'Employment',
      url: this.paths.loans.application_flow_employment,
      editable: false,
      completed: this.hasApplicationEmploymentInformation()
    }, {
      title: 'Income',
      url: this.paths.loans.application_flow_income,
      editable: false,
      completed: this.hasIncomeInformation()
    }, {
      title: 'Loan customization',
      url: this.paths.loans.application_flow_loan_customization,
      editable: false,
      completed: this.hasLoanCustomization()
    }, {
      title: 'Review',
      url: this.paths.loans.application_flow_review,
      editable: false,
      completed: this.hasReviewedApplication()
    }, {
      title: 'Bank verification',
      url: this.paths.loans.application_flow_bank_introduction, // go to introduction page first
      editable: false,
      completed: this.hasCompletedApplication()
    }];
    if (this.presenter.models.account.phone_number) {
      this.trayItems.splice(1, 1);
    }
    this._createTrayNavigation();
    this._initializeLoanApplicationFlowNavigation();
    this._routeToPath();
  };

  this.destroy = function () {
    this._super();
  };

  // Conditions:
  // 1) Offer is Active
  // 2) Offer Name is Liquid,
  // 3) is NOT paid off
  this._isLoanApplicationEligible = function () {
    var activeOfferName = this._activeOffer.getOfferName(); // Liquid
    var offerStatus = this._getOfferStatus(); // Active or Enhanced
    var loanStatusObj = this._getLoanStatus();
    var loanStatus = '';

    //  loanStatus might return null
    if (loanStatusObj) {
      loanStatus = loanStatus.status;
    }

    if ((offerStatus === 'active' || offerStatus === 'enhanced') && activeOfferName === 'liquid' && loanStatus !== 'paid_off') {
      return true;
    }
    return false;
  };

  this._createTrayNavigation = function () {
    $('#LoanApplicationTray .tray-navigation').mogo().create('TrayNavigation', {
      steps: {
        items: this.trayItems,
        sequential: false, // fix next step being editable when in edit mode
        selectedIndex: 0
      },
      progressIndicator: 'percent'
    });
  };

  // TODO: resume previous state (set finished steps to completed), set the current step to the one user left at. Wait for BE to be ready.
  this._initializeLoanApplicationFlowNavigation = function () {
    var _this = this;

    mogo.ready(function () {
      _this.loanAppSideTray = $('#LoanApplicationTray .tray-navigation').mogo();
      var index = 0;
      for (var i = 0; i < _this.loanAppSideTray._listItems.length; i++) {
        _this.loanAppSideTray.setDisabled(i);
        _this.loanAppSideTray.disableEditable(i);
        // use this value to set index
        if (_this.path === _this.trayItems[i].url) {
          // Enable first step for when the tray is collapsed on mobile screen
          _this.loanAppSideTray.setEnabled(i);
          index = i;
        }
      }
      _this.loanAppSideTray.setSelectedIndex(index);
      // check if all the prior to to the last step are completed
      var lastIndex = _this.loanAppSideTray._listItems.length - 1;
      if (_this.trayItems[lastIndex].completed === true) {
        _this.loanAppSideTray.setEnabled(lastIndex);
      }
    });
  };

  // Returns the step that the user should be in.
  this._getCurrentStep = function () {
    for (var i = 0; i < this.trayItems.length; i++) {
      var stepCompleted = this.trayItems[i].completed;
      // at the step thats not completed
      if (!stepCompleted) {
        return this.trayItems[i].url;
      }
    }
  };

  this._isStepCompleted = function (currentPathUrl) {
    var currentPath = currentPathUrl;

    for (var i = 0; i < this.trayItems.length; i++) {
      if (currentPath === this.trayItems[i].url) {
        var stepCompleted = this.trayItems[i].completed;

        return stepCompleted;
      }
    }
  };

  this._routeToPath = function () {
    var _this2 = this;

    var currentStep = this._getCurrentStep();

    mogo.ready(function () {
      // Need tray navigation to invoke to get current index.
      var currentIndex = $('#LoanApplicationTray .tray-navigation').mogo().getSelectedIndex();

      if (!_this2._isLoanApplicationEligible()) {
        return _this2.history.goToUrl(_this2.paths.account.dashboard);
      }

      // Route User to complete page if the application has been completed
      if (_this2.hasCompletedApplication()) {
        return _this2.history.goToUrl(_this2.paths.loans.application_status);
      }
      if (_this2.isBankRelink()) {
        // Route User to bank introduction page if status is relink
        // Users are not allow to edit on review screen when they are in this status
        _this2.loanAppSideTray.setDisabled(currentIndex);
        _this2.history.goToUrl(_this2.paths.loans.application_flow_bank_introduction);
        // Enable the step after the reroute
        _this2.loanAppSideTray.setEnabled($('#LoanApplicationTray .tray-navigation').mogo().getSelectedIndex());
      } else {
        // else route to correct step
        if (!_this2._isStepCompleted(_this2.path) || _this2.path !== currentStep) {
          _this2.loanAppSideTray.setDisabled(currentIndex);
          _this2.history.goToUrl(currentStep);
          // Enable the step after the reroute (for mobile step menu)
          _this2.loanAppSideTray.setEnabled($('#LoanApplicationTray .tray-navigation').mogo().getSelectedIndex());
          return;
        }
      }
    });
  };

  this._loanAppGoToNextStep = function (e) {
    if (e) e.preventDefault();
    if (!this.loanAppSideTray.declaredClass) return; // Component not created yet

    if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      // checks 'money._loanApplicationEdit
      this.history.goToUrl(this.paths.loans.application_flow_review);
    } else {
      var currentIndex = this.loanAppSideTray.getSelectedIndex();
      this.loanAppSideTray.setCompleted(currentIndex);
      this.loanAppSideTray.disableEditable(currentIndex);
      this.loanAppSideTray.setDisabled(currentIndex);
      this.loanAppSideTray.setEnabled(currentIndex + 1);
      this.loanAppSideTray.goToNextStep();
    }
  };

  this._loanAppGoToPreviousStep = function (e) {
    if (e) e.preventDefault();

    if (!this.loanAppSideTray.declaredClass) return; // Component not created yet
    var currentIndex = this.loanAppSideTray.getSelectedIndex();
    if (currentIndex === 0) {
      this._history.goToUrl(this.paths.loans.application_flow_start);
    } else if (currentIndex > 0) {
      this.loanAppSideTray.goToPreviousStep();
    }
  };

  this._loanAppSetStepComplete = function (e) {
    if (e) e.preventDefault();

    if (!this.loanAppSideTray.declaredClass) return; // Component not created yet
    var currentIndex = this.loanAppSideTray.getSelectedIndex();
    this.loanAppSideTray.setCompleted(currentIndex);
    this.loanAppSideTray.disableEditable(currentIndex);
    this.loanAppSideTray.setDisabled(currentIndex);
    this.loanAppSideTray.deselectIndex(currentIndex);
  };

  this.goToLoanApplicationStep = function (path) {
    var currentStep = path;
    if (currentStep && typeof currentStep === 'string') {
      _this3.loanAppSideTray = $('#LoanApplicationTray .tray-navigation').mogo();

      for (var i = 0; i < _this3.trayItems.length; i++) {
        _this3.loanAppSideTray.setSelectedIndex(i);
        if (currentStep.includes(_this3.trayItems[i].url)) {
          _this3._history.goToUrl(currentStep);
          return;
        }

        _this3.loanAppSideTray.setCompleted(i);
      }
    } else {
      console.warn('The step path is missing');
    }
  };

  this._pushCloseAnalytics = function () {
    this.analytics.forcePushEvent('generic-member-navigation', {
      memberNavigation: ['Money-Navigation-Previous-Navigation-Component']
    });
  };

  this.removeEdit = function () {
    if (this.presenter.getModelProperty('money._loanApplicationEdit')) {
      this.presenter.removeModelProperty('money._loanApplicationEdit');
    }
  };

  // ############ Step complete checks #################

  this.hasLoanApplication = function () {
    if (this.hasCreatedLoanApplication() && // method from money controller
    this.hasApplicationEmploymentInformation()) {
      return true;
    }
    return false;
  };

  this.hasPhoneVerification = function () {
    return !!this.presenter.getModelProperty('account.phone_number');
  };

  this.hasApplicationEmploymentInformation = function () {
    if (this._loanApplications.length) return this._loanApplications[0].hasSubmittedEmployment();
  };

  this.hasIncomeInformation = function () {
    if (this._loanApplications.length) return this._loanApplications[0].hasSubmittedIncome();
  };

  this.hasLoanCustomization = function () {
    if (this._loanApplications.length) return this._loanApplications[0].hasSubmittedLoanAmount();
  };

  this.hasCompletedApplication = function () {
    var completedStatus = ['outstanding_docs', 'initial_review', 'additional_review', 'additional_conditions', 'agreements_ready', 'agreements_expired', 'agreements_signed', 'originated'];

    if (this._loanApplications.length && completedStatus.includes(this._loanApplications[0].getStatus())) {
      return true;
    }
    return false;
  };

  this.isBankRelink = function () {
    return this._loanApplications.length && this._loanApplications[0].getStatus() === 'relink' && this._loanApplications[0].getRelinkReason();
  };

  this.hasReviewedApplication = function () {
    if (this._loanApplications.length) return this._loanApplications[0].hasSubmittedReview();
  };
}